import React from "react";
import moment from "moment";
import { isEmpty } from "lodash";
import { TodoPriority, TodoSearchItemFragment, TodoStatus } from "@graphql";
import locale from "@bonliva-crm/locale";
import {
  AccessAlarm,
  CheckCircle,
  HowToReg,
  LocalOffer,
  LowPriority,
  Person,
  PriorityHigh,
  CalendarToday
} from "@material-ui/icons";
import { useTheme } from "@material-ui/core";

export function getTicketDetails(ticket: TodoSearchItemFragment) {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const theme = useTheme();

  const assignedToName = ticket.assignedTo || "None";

  const result: Array<{
    key: string;
    icon: React.ComponentType;
    title: React.ReactNode;
    label: React.ReactNode;
  }> = [];

  if (ticket.dueDate) {
    result.push({
      key: "deadline",
      icon: AccessAlarm,
      title: locale.ticketsCard.deadline,
      label: (
        <span style={{ color: theme.palette.primary.main }}>
          {moment.utc(ticket.dueDate).format("L")}
        </span>
      )
    });
  }

  result.push({
    key: "createdOn",
    icon: CalendarToday,
    title: locale.ticketsCard.assignedOn,
    label: moment.utc(ticket.createdOn).format("YYYY-MM-DD")
  });

  result.push({
    key: "assignedTo",
    icon: Person,
    title: locale.ticketsCard.assignedTo,
    label: assignedToName
  });

  result.push({
    key: "assignedBy",
    icon: Person,
    title: locale.ticketsCard.customer,
    label: ticket.assignedBy
  });

  if (ticket.priority && ticket.priority !== TodoPriority.NoStatus) {
    result.push({
      key: "priority",
      icon: ticket.priority === TodoPriority.High ? PriorityHigh : LowPriority,
      title: locale.ticketsCard.priority,
      label:
        ticket.priority === TodoPriority.High ? (
          <span style={{ color: theme.palette.error.main }}>
            {locale.ticketsCard.highPriority}
          </span>
        ) : (
          locale.ticketsCard.lowPriority
        )
    });
  }

  if (ticket.managedBy) {
    result.push({
      key: "acceptedBy",
      icon: HowToReg,
      title: locale.ticketsCard.acceptedBy,
      label: ticket.managedBy
    });
  }

  if (ticket.status) {
    result.push({
      key: "status",
      icon: CheckCircle,
      title: locale.ticketsCard.status,
      label: `${locale.todoStatus[ticket.status]} ${
        ticket.status === TodoStatus.Done
          ? moment.utc(ticket.completedOn).format("L")
          : ""
      }`
    });
  }

  if (!isEmpty(ticket.tags)) {
    result.push({
      key: "tags",
      icon: LocalOffer,
      title: locale.ticketsCard.tags,
      label: ticket.tags.join(", ")
    });
  }

  return result;
}
